// extracted by mini-css-extract-plugin
module.exports = {"Emoji":"vt_a bag_i bag_q bag_j"};